import { Component, OnInit, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { ToastsManager } from 'ng2-toastr';
import { FreshServiceOffboardingForm } from '../../../../models/FreshServiceOffboardingForm.model';
import { ConsultantService } from '../../../../services/consultant.service';
import { CommonHelper } from "../../../../shared/helpers/CommonHelper";
import { LaptopTransportType } from "../../../../shared/enums/LaptopTransportType";
import * as moment from 'moment';

@Component({
    selector: 'modal-freshservice-offboarding',
    templateUrl: './modalFreshServiceOffboarding.html',
    styleUrls: ['./modalFreshServiceOffboarding.css']
})
export class ModalFreshServiceOffiboarding implements OnInit {
    @Input() freshServiceOffboardingForm: FreshServiceOffboardingForm;
    @Output() sendOffboardingData: EventEmitter<any> = new EventEmitter();
    @Output() closeOffboardingForm: EventEmitter<boolean> = new EventEmitter();
    dateMask = [/[0-3]/,/[0-9]/,'/',/[0-3]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/];
    datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
    LaptopTransportType = LaptopTransportType;
    commonHelper: CommonHelper = new CommonHelper();
    selectedTransportType = 0;
    offboardingFormValid: boolean = false;
    transportationServices = [LaptopTransportType.Consultant, LaptopTransportType.Loggi, LaptopTransportType.Dhl];

    constructor(
        private consultantService: ConsultantService,
        private toast: ToastsManager,
    ) {}

    ngOnInit() {}

    ngOnChanges(changes: SimpleChanges) {
        this.validateOffboardingForm();
    }

    verifyFreshServiceLoggiFormDate(date,field){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toast.warning(`Digite uma data válida.`,"Data inválida!");
            this.freshServiceOffboardingForm[`${field}`] = "";
        }else if (date) {
            const isValidDate = moment(date, 'DD/MM/YYYY');
            if (isValidDate && !isValidDate.isValid()) {
            this.freshServiceOffboardingForm[`${field}`] = '';
            this.toast.warning(
                `Digite uma data válida.`,
                'Data inválida!'
                );
            };
        }

        let today = new Date();
        const todayWithoutHourMinutes = moment(today).format("YYYY-MM-DD");
        const formattedDate = this.freshServiceOffboardingForm[`${field}`].split("/").reverse().join("-") || '';
        if (formattedDate !== '' && moment(formattedDate).isBefore(todayWithoutHourMinutes)) {
            this.freshServiceOffboardingForm[`${field}`] = '';
            this.toast.warning(
                `A data de retirada não pode ser menor que a data de hoje.`,
                'Data inválida!'
                );
        }
        this.validateOffboardingForm();
    }

    async loggiCepSearch() {
        let cep = this.freshServiceOffboardingForm.cep;
        cep = cep.replace(/\-/g, "");
        if(cep == '' || cep.length != 8){
            this.toast.warning('CEP inválido');
        } else {
            this.toast.warning('Realizando consulta ao CEP...');
            let response = await this.consultantService.getCep(cep);
            this.freshServiceOffboardingForm.address = response.logradouro;
            this.freshServiceOffboardingForm.number = response.numero;
            this.freshServiceOffboardingForm.district = response.bairro;
            this.freshServiceOffboardingForm.city = response.localidade;
            this.freshServiceOffboardingForm.state = response.uf;
        }
        this.validateOffboardingForm();
    }

    validateOffboardingForm(): void {
        const laptopTransportTypeValid = !!this.freshServiceOffboardingForm.laptopTransportType;
        const consultantValid = this.isConsultantFormFieldsValid();
        if ((Number(this.freshServiceOffboardingForm.laptopTransportType) == LaptopTransportType.Consultant)) {
            this.freshServiceOffboardingForm.collectDate = moment(new Date()).format('DD/MM/YYYY')
            this.freshServiceOffboardingForm.collectTime =  'Manhã'
        }
        const transportationFieldsValid = this.areTransportationFieldsValid();
        this.offboardingFormValid = laptopTransportTypeValid && consultantValid &&
            ((Number(this.freshServiceOffboardingForm.laptopTransportType) == LaptopTransportType.Consultant) ||
            transportationFieldsValid);
    }

    isConsultantFormFieldsValid(): boolean {
        const fields = [
            'email',
            'name',
            'cpf',
            'laptopTransportType',
        ];
        let isValid = true;
        fields.forEach((field) => {
            if (!this.freshServiceOffboardingForm[field]) {
                isValid = false;
            }
        })
        return isValid;
    }

    areTransportationFieldsValid(): boolean {
        if (!this.transportationServices.includes(Number(this.freshServiceOffboardingForm.laptopTransportType)))
            return true;

        const fields = [
            'address',
            'number',
            'city',
            'district',
            'state',
            'cep',
            'collectDate',
            'collectTime',
            'laptopTransportType'
        ];
        let isValid = true;
        fields.forEach((field) => {
            if (!this.freshServiceOffboardingForm[field]) {
                isValid = false;
            }
        });
        if(Number(this.freshServiceOffboardingForm.state) == 0)
            isValid = false;
        return isValid;
    }

    clear() {
        this.freshServiceOffboardingForm = new FreshServiceOffboardingForm();
    }

    cancelOffboardingForm() {
        this.clear();
        this.closeOffboardingForm.emit(true);
    }

    saveOffboardingForm() {
        this.sendOffboardingData.emit(this.freshServiceOffboardingForm);
    }
}



// WEBPACK FOOTER //
// ./src/app/views/consultants/components/modalFreshServiceOffboarding/modalFreshServiceOffboarding.ts